import i18n from '@/libs/i18n/index'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'
import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function useUsersList() {
  function convertResource(resource) {
    return {
      ...resource,
      phoneNumber: resource.phoneNumber ? resource.phoneNumber.replace(/^9/, '09') : '',
    }
  }

  const MODULE_NAME = 'users'
  const ENDPOINT = 'users'
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const roleOptions = ref([])
  const role = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'fullName', label: i18n.t('users.fullName'), icon: 'UserIcon' },
    {
      key: 'phoneNumber', label: i18n.t('general.phone'), sortable: false, icon: 'SmartphoneIcon',
    },
    {
      key: 'roles', label: i18n.t('users.roles'), sortable: false, icon: 'UserCheckIcon',
    },
    {
      key: 'isDeactivate', label: i18n.t('users.deactivated'), sortable: false, icon: 'MinusIcon',
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = roleEntry => {
    if (roleEntry === 'user') return 'info'
    if (roleEntry === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = roleEntry2 => {
    if (roleEntry2 === 'user') return 'UserIcon'
    if (roleEntry2 === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const fetchUserRoles = (lang = 'fa', search = '') => {
    entity.itemLoading.value = true
    store
      .dispatch('crud/fetchList', {
        queryParams: { lang, search },
        endpoint: 'roles',
      })
      .then(response => {
        roleOptions.value = response.data.map(item => item.roleName)
      })
      .catch(err => {
        useErrorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        entity.itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  return {
    ...entity,
    convertResource,
    fetchUserRoles,
    resolveUserRoleIcon,
    resolveUserRoleVariant,
    role,
    roleOptions,
    tableColumns,
  }
}
